'use client';

import {createTheme} from "@mui/material/styles";

export const muiTheme = createTheme({
    palette: {
        primary: {
            main: '#436B78' //'rgb(40, 59, 123)'
        },
        secondary: {
            main: '#D8C149'//'rgb(92, 156, 150)',
        },
    },
    typography: {
        fontFamily: '"GeneralSans", sans-serif',
    }
});
